import { render, staticRenderFns } from "./NotificationTab.vue?vue&type=template&id=24e98228"
import script from "./NotificationTab.vue?vue&type=script&lang=js"
export * from "./NotificationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports